import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import VehicleBasicInfoComponent from './vehicle-basic-info.component';
import MediaInfoComponent from '../../../../../../common/components/common/media-info.component';

export const VehicleComponent = ({ mediaFiles, handleFormMediaItemChange, fileTypes, changeImage, handleInnerFormChange, selectedVehicle, transportAgents, transporters, back, handleFormSubmit }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'vehicle Information',
      component: <VehicleBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedVehicle={selectedVehicle}
        transporters={transporters}
        transportAgents={transportAgents}
      />,
      isVisible: true,
    },
    {
      id: 4,
      title: 'Media',
      component:
        <MediaInfoComponent
          changeImage={changeImage}
          // deleteSelectedProduct={deleteSelectedCategory}
          fileTypes={fileTypes}
          //handleClose={handleClose}
          //handleOpen={handleOpen}
          onFormItemChange={handleFormMediaItemChange}
          // openConfirmation={openConfirmation}
          mediaFiles={mediaFiles}
        //uploadToDigiiFolder={uploadToDigiiFolder}
        />,
      isVisible: true,
    }
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default VehicleComponent;
